import React from 'react'
import style from './TextInput.module.css'

const TextArea = ({name, onChange, value, title, type, placeholder, id, className}) => {
  return (
    <div className={`${className} ${style.cover}`}>
      <label htmlFor={id}>{title}</label>
      <textarea 
        name={name}
        value={value}
        id={id}
        onChange={onChange}
        placeholder={placeholder}
        className={style.textArea}
      />
    </div>
  )
}

export default TextArea